import { getFileUrl } from "./telegram";

/**
 * Fetch file bytes via the same-origin storage proxy. Works for both
 * Telegram-backed files (`/api/tg/file?id=…`) and B2-backed files
 * (`/api/b2/file?key=…`) — the URL is picked by `getFileUrl()`.
 *
 * Name kept for backwards compatibility with existing imports.
 */
export async function fetchTelegramFileBlob(file, mime = "application/octet-stream") {
  if (!file) throw new Error("file required");

  const url = getFileUrl(file);
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Could not load file (HTTP ${res.status})`);
  }

  const blob = await res.blob();
  if (blob.size === 0) {
    throw new Error("Empty file response");
  }

  return new Blob([await blob.arrayBuffer()], { type: mime });
}
